import { useEffect, useState } from "react";
import api from "../services/api";

export default function useApiData(endpoint, fallbackData) {

  const [data, setData] = useState(fallbackData);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {

    async function fetchData() {
      try {

        const response = await api.get(endpoint);

        setData(response.data);

      } catch (err) {

        setError(err);
        setData(fallbackData);

      } finally {

        setLoading(false);

      }
    }

    fetchData();

  }, [endpoint]);

  return { data, loading, error };
}